import { Tooltip } from "@mui/material";
import { ProgressCircle, ProgressCircleTrail, SvgCircleContainer } from "./ProgressCircle.styles";
import type { LearnerProgressItem } from "../../types";

type IProgress = {
  progress: number, //progress va da 0 a 100 
  radius: number, //radius è in pixel
  r: string,
  courseInfo: LearnerProgressItem;
  courseTag: string;
  onHover: (id: string | number | null) => void
  isHover: (id: string | number | null) => boolean | undefined;
}

export const Progress = ({
  progress,
  radius,
  r,
  courseInfo,
  courseTag,
  onHover,
  isHover
}: IProgress) => {

  function calculateStrokeDash(progress: number, radius: number) {
    if (progress === 100) return null;
    if (progress === 0) progress = 0.1;
    const dashArray = 2 * Math.PI * Number(radius);
    const dashOffset = dashArray * ((100 - Number(progress)) / 100);

    return { strokeDasharray: dashArray, strokeDashoffset: dashOffset };
  }

  const handleTooltip =()=> `${courseInfo?.completedLos ?? "0"} / ${courseInfo?.los ?? "0"}`;

  return (
    <Tooltip title={ handleTooltip() } placement="top">
      <SvgCircleContainer
        id={ courseTag + "-svg-progression" }
        onMouseOver={ () => onHover(courseTag) }
        onMouseLeave={ () => onHover(null) }
        isHover={ isHover(courseTag) }
      >
        <ProgressCircleTrail id={ courseTag + "-trail-circle" } className="trail-circle" r={ r } />
        <ProgressCircle
          id={ courseTag + "-progress-circle" }
          className="progress-circle"
          r={ r }
          strokesDash={ calculateStrokeDash(progress, radius) }
          style={ { transform: "rotate(-90deg)" } }
          mandatory={ courseTag === "MANDATORY_ATTRIBUTE" }
        />
      </SvgCircleContainer>
    </Tooltip>
  );
};
